import { Language } from '@/store/user/types'

export const getBrowserLanguage = () => {
  const navigationLanguage = navigator?.languages?.[0] || navigator?.language
  return navigationLanguage?.toLowerCase().split(/[_-]+/)[0]
}

export const getDefaultLanguage = (): Language => {
  const browserLanguage = getBrowserLanguage()

  return browserLanguage === Language.Russian ? Language.Russian : Language.English
}
